import type { CampaignActivityLog } from "@/marketing/models/campaignActivity";

// Facade records Business Portal members as `business:<userId>`; staff never see that id resolved.
const BUSINESS_PORTAL_AUTHOR_PREFIX = "business:";

export function getActivityAuthorLabel(entry: CampaignActivityLog): string {
  if (!entry.authorId) return "System";
  if (entry.authorId.startsWith(BUSINESS_PORTAL_AUTHOR_PREFIX)) {
    return "Brand (Business Portal)";
  }
  return entry.authorId;
}
